import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  appStatus: true,
  moneyFormat: '',
  shopInfo: {
    shopOwner: '',
    email: '',
    shopName: '',
    myshopifyDomain: ''
  },
  shop_info: {},
  listNotification: [],
  listProductsViewed: [],
  notificationsDetail: null,
  upgradePlanPackageResult: {},
  buyMorePackageResult: {},
  clickTopPin: {
    product_history: 0,
    top_discount: 0,
    trending_product: 0,
    best_selling: 0
  },
  checkVariants: false,
  viewTopPin: {
    product_history: 0,
    top_discount: 0,
    trending_product: 0,
    best_selling: 0
  },

  statisticChart: {
    data_product_views: [],
    data_toppin_clicks: [],
    data_toppin_views: [],
    footer_value: []
  },

  viewByPlan: {
    last_date_charge: '2021-10-08',
    view_current: 26,
    view_limit: 1000,
    view_product_history: 0,
    view_top_discount: 0,
    view_trending_product: 0,
    view_best_selling: 0
  },
  detailPackage: {},
  changeAppStatusLoading: false,
  changeAppStatusResult: 0
});

let result = '';

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_SETTING_APP_RESULT:
      result = action.res;
      if (result) {
        return state.set('appStatus', result.status).set('moneyFormat', result.money_format);
      }
      return state;
    case types.CHANGE_APP_STATUS:
      return state
        .set('appStatus', !state.get('appStatus'))
        .set('handleStatusLoading', true)
        .set('handleStatusResult', 0)
        .set('changeAppStatusLoading', true)
        .set('changeAppStatusResult', 0);
    case types.GET_STATISTIC_CHART_RESULT:
      if (action.res) {
        return state.set('statisticChart', fromJS(action.res));
      }
      return state;
    case types.GET_TOP_PRODUCTS_VIEWED_RESULT:
      result = action.res.products;
      if (result) {
        return state.set('listProductsViewed', fromJS(result));
      }
      return state;
    case types.SET_CHECK_VARIANTS:
      return state.set('checkVariants', true);
    case types.CHANGE_APP_STATUS_RESULT:
      return state
        .set('appStatus', state.get('appStatus'))
        .set('handleStatusLoading', true)
        .set('handleStatusResult', 0)
        .set('changeAppStatusLoading', false)
        .set('changeAppStatusResult', { success: false, ...action.payload }.success ? 1 : 2);
    case types.GET_LIST_NOTIFICATION_RESULT:
      return state.set('listNotification', fromJS(action.payload));
    case types.GET_NOTIFICATION_DETAIL_RESULT:
      return state.set('notificationsDetail', fromJS(action.payload[0]));
    case types.UPGRADE_PLAN_PACKAGE_RESULT:
      return state.set('upgradePlanPackageResult', fromJS(action.payload));
    case types.BUY_MORE_PACKAGE_RESULT:
      return state.set('buyMorePackageResult', fromJS(action.payload));
    case types.RESET_PACKAGE_RESULT_STATUS:
      return state
        .set('upgradePlanPackageResult', fromJS({}))
        .set('buyMorePackageResult', fromJS({}));
    case types.SET_DATA_SHOP_RESULT:
      return state.set('shop_info', fromJS(action.payload));

    case types.GET_REPORT_APP_RESULT:
      result = action.res;
      if (result && result.click_top_pin && result.view_top_pin) {
        return state
          .set('clickTopPin', fromJS(result.click_top_pin))
          .set('viewTopPin', fromJS(result.view_top_pin));
      }
      return state;

    case types.GET_PLAN_PACKAGE_REUSLT:
      result = action.res;
      if (result) {
        return state.set('detailPackage', fromJS(result));
      }
      return state;
    default:
      return state;
  }
};

export default appReducer;
